import { z } from 'zod'

export const schema = z.object({
  cottageConditions: z
    .object({
      conditionsId: z.string(),
      timeIn: z.string().nullable().optional(),
      timeOut: z.string().nullable().optional(),
      moreConditions: z.string().nullable().optional(),
      cottageConditionsAdvance: z.object({
        type: z.enum(['PERCENT', 'FIX', 'NO']),
        percent: z.number().nullable().optional(),
        fixValue: z.number().nullable().optional(),
      }),

      cancellationPolicy: z.object({
        type: z.enum(['YES', 'NO']),
        values: z.array(
          z.object({
            days: z.number().int(),
            date: z.string().nullable(),
            percent: z.number(),
          }),
        ),
      }),

      deposit: z.object({
        type: z.enum(['PERCENT', 'FIX', 'NO']),
        percent: z.number().nullable().optional(),
        fixAmount: z.number().nullable().optional(),
        fixAmountCurrency: z.string().nullable().optional(),
      }),
    })
    .nullable()
    .optional(),
  isFreeCancellation: z.boolean(),
})

export type schemaType = z.infer<typeof schema>
